/*

In order to use Bootstrap 4 without collision from our existing styles, we use
the Svelte head injector to bring in the pre-built styles, as well as to apply
a very small font size reset that the initial styles apply.

This means that building anything in Bootstrap 4 will need to have the entire
page transitioned to 4, e.g. the NavBar will need to use class names and styles
from 4 before we can setup a new page within the existing Portal pages and have
it look nice.

This also means that, at the root of wherever we're setting up a new view, for
example at the start of every Storybook `*.stories.svelte` file, and at the very
top parent route, we will need to include this component, aka:

*/

const nameToUrl = {
    modern: 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/css/bootstrap.min.css',
    legacy: (window.fanxVersion && window.fanxVersion.urlPrefix || '') + 'legacy.css'
}

const inject = (name, container = window) => {
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = nameToUrl[name]
    return container.document.getElementsByTagName('head')[0].appendChild(link)
}

const injected = {}

const cleanup = (name) => {
    Object.keys(injected).forEach(key => {
        if (injected[name] && key !== name) {
            injected[key].remove()
            window.requestAnimationFrame(() => {
                delete injected[key]
            })
        }
    })
}

window.fanxSetPortalTheme = (name) => {
    nameToUrl.bootswatch = `https://stackpath.bootstrapcdn.com/bootswatch/4.5.2/${name}/bootstrap.min.css`
    inject('bootswatch')
    cleanup('bootswatch')
}

export default async (name = 'modern', container = window) => new Promise(resolve => {
    if (!injected[name]) {
        injected[name] = inject(name, container)
        injected[name].onload = () => {
            window.requestAnimationFrame(() => {
                cleanup(name)
                resolve()
            })
        }
    } else {
        window.requestAnimationFrame(resolve)
    }
})
